import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, Spinner, Alert } from 'react-bootstrap';

const StripeCheckoutForm = ({ onPaymentSuccess, onPaymentError }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [elementError, setElementError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required'
    });

    if (error) {
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("Ein unerwarteter Fehler ist aufgetreten.");
        }
        if (onPaymentError) onPaymentError(error);
    } else {
        setMessage(`Zahlung erfolgreich! Transaktions-ID: ${paymentIntent.id}`);
        if (onPaymentSuccess) onPaymentSuccess(paymentIntent);
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {elementError ? (
        <Alert variant="danger">{elementError}</Alert>
      ) : (
        <PaymentElement
          id="payment-element"
          options={paymentElementOptions}
          onLoadError={(event) => {
            const text = (event && event.error && event.error.message)
              || 'Das Zahlungsformular konnte nicht geladen werden. Bitte prüfen Sie, ob der veröffentlichbare und der geheime Stripe-Schlüssel zum selben Konto gehören.';
            setElementError(text);
            if (onPaymentError) onPaymentError(event.error || { message: text });
          }}
        />
      )}
      <Button type="submit" disabled={isLoading || !stripe || !elements} id="submit" style={{ marginTop: '20px', width: '100%' }}>
        <span id="button-text">
          {isLoading ? <Spinner animation="border" size="sm" /> : "Jetzt sicher bezahlen"}
        </span>
      </Button>
      {message && <Alert variant={message.includes('erfolgreich') ? 'success' : 'danger'} style={{ marginTop: '20px' }} id="payment-message">{message}</Alert>}
    </form>
  );
};

export default StripeCheckoutForm;